import { Button } from "antd";
import { FacebookFilled } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

export default function Oa() {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col h-full">
            <div className="flex flex-col items-center justify-center text-center py-12">
                {/* ICONS */}
                <div className="flex items-center gap-6 mb-6">

                    {/* Buso Icon */}
                    <div className="w-[48px] h-[48px] bg-white rounded-full shadow-md flex items-center justify-center">
                        <div className="w-10 h-10 rounded-full flex items-center justify-center text-white text-xl">
                            <img src="https://khothi.buso.asia/uploads/2025/10/photo_library/i0sGPLyOtv3a2fb45cb6264d9f6848b54d45c8a57f.png" alt="Buso" className="w-full h-full object-contain" />
                        </div>
                    </div>

                    {/* Arrow */}
                    <div className="icon"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#3e91ab" viewBox="0 0 256 256"><path d="M24,128A72.08,72.08,0,0,1,96,56H204.69L194.34,45.66a8,8,0,0,1,11.32-11.32l24,24a8,8,0,0,1,0,11.32l-24,24a8,8,0,0,1-11.32-11.32L204.69,72H96a56.06,56.06,0,0,0-56,56,8,8,0,0,1-16,0Zm200-8a8,8,0,0,0-8,8,56.06,56.06,0,0,1-56,56H51.31l10.35-10.34a8,8,0,0,0-11.32-11.32l-24,24a8,8,0,0,0,0,11.32l24,24a8,8,0,0,0,11.32-11.32L51.31,200H160a72.08,72.08,0,0,0,72-72A8,8,0,0,0,224,120Z"></path></svg></div>

                    {/* Instagram Icon */}
                    <div className="w-[48px] h-[48px] !rounded-full flex items-center justify-center text-white text-3xl shadow-md overflow-hidden">
                        <img src="https://pancake.vn/static/images/platform-connection/zalo.png" alt="Buso" className="w-full h-full object-contain" />
                    </div>
                </div>

                {/* TITLE */}
                <h2 className="text-xl font-semibold text-gray-800 mb-3 max-w-[340px]">
                    {t('chats.connect_zalo_oa')}
                </h2>

                {/* DESCRIPTION */}
                <p className="text-gray-500 max-w-[340px] text-sm mb-8 leading-relaxed">
                    {t('chats.zalo_oa_desc')}
                </p>

                <Button
                    size="large"
                    className="
                        w-[340px]
                        h-[42px]
                        flex items-center justify-center gap-2
                        hover:!border-[#3e91ab]
                        hover:!border-[#3e91ab]
                        bg-[#3e91ab]
                        hover:!bg-[#357f96]
                        hover:border-[#357f96]
                        text-white
                        hover:!text-white
                    "
                >
                    <div className="w-[20px] h-[20px]">
                        <img className="platform-icon-img facebook rounded-[4px]" src="https://pancake.vn/static/images/platform-connection/zalo.png" alt="zalo" />
                    </div>
                    <span className="font-medium">
                        {t('chats.connect_zalo_oa_btn')}
                    </span>
                </Button>

                {/* GUIDE LINK */}
                <div className="flex items-start gap-2 text-sm text-gray-600 max-w-[340px] mt-4">
                    {/* ICON */}
                    <div className="mt-[2px] text-gray-500">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            viewBox="0 0 256 256"
                        >
                            <path d="M140,180a12,12,0,1,1-12-12A12,12,0,0,1,140,180ZM128,72c-22.06,0-40,16.15-40,36v4a8,8,0,0,0,16,0v-4c0-11,10.77-20,24-20s24,9,24,20-10.77,20-24,20a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-.72c18.24-3.35,32-17.9,32-35.28C168,88.15,150.06,72,128,72Zm104,56A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" />
                        </svg>
                    </div>

                    {/* TEXT */}
                    <div className="text-left">
                        <a
                            id="tiktok-business-help"
                            href="https://pke.gg/493xj5ay"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-[#357f96] hover:underline"
                        >
                            {t('chats.guide_link')}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}